import axios from "axios";
import { API_BASE_URL } from "../constant";

export const fetchReportData = async (Token) => {
  try {
    const config = {
      method: 'get',
      url: `${API_BASE_URL}/get_report_list`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Token,
      },
      withCredentials: true,
      data: {
        report_category: "All",
      },
    };
    console.log(config);

    const response = await axios(config);
    console.log("Fetched Reports:dkfkrej", response.data);

    return response.data
  } catch (error) {
    console.error("Error fetching reports:", error);
    // throw error; // optionally re-throw to handle it in calling code
  }
};

export const getReportJSON = async (reportName, filters, paginationInfo) => {
  const userToken = localStorage.getItem("user_token");

  try {
    const payload = {
      report_type: 'csv',
      limit: paginationInfo?.limit,
      offset: paginationInfo?.offset,
      filters: Object.keys(filters).length > 0 ? filters : undefined,
      report_name: reportName
    };
    // if (reportName === "Candere Outward Register") {
    //   delete payload.filters
    // }
    const config = {
      method: 'post',
      url: `${API_BASE_URL}/getreport`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': userToken,
      },
      withCredentials: true,
      data: payload
    };

    const response = await axios(config);
    console.log("Fetched Reports:", response.data);
    return response.data;

  } catch (error) {
    console.error('Error fetching report JSON:', error);

    // throw error; // Optional: rethrow if you want to handle it further up the chain
  }




};

export const GetStoresList = async () => {
  try {

    const userToken = localStorage.getItem("user_token");

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/get_warehouse_list`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': userToken,
      },
      withCredentials: true,
      data: {}
    };

    const response = await axios(config);
    console.log("Fetched Reports:", response.data);
    return response.data;

  } catch (error) {
    console.error('Error fetching report JSON:', error);

    // throw error; // Optional: rethrow if you want to handle it further up the chain
  }
}



export const GetFiscalYearList = async () => {
  try {

    const userToken = localStorage.getItem("user_token");

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/get_fiscal_year_list`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': userToken,
      },
      withCredentials: true,
      data: {}
    };

    const response = await axios(config);
    return response.data;

  } catch (error) {
    console.error('Error fetching report JSON:', error);

  }
}

export const GetCompanyList = async () => {
  try {

    const userToken = localStorage.getItem("user_token");

    const config = {
      method: 'GET',
      url: `${API_BASE_URL}/get_company_list`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': userToken,
      },
      withCredentials: true,
      data: {}
    };

    const response = await axios(config);
    return response.data;

  } catch (error) {
    console.error('Error fetching report JSON:', error);

  }
}
